import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import DialogSession from '@ricoh/ria.client.core/components/dialog/session';

import { SESSION_DURATION, SESSION_TIMEOUT_COUNTER_INITIAL_VALUE } from '~/common/constants/feature/auth/session-timeout';

import type { SessionTimeoutProps, SessionTimeoutRef } from './_.type';

import useSessionTimeoutHooks from './_.hook';

/** SessionTimeout. */
export default memo(
  forwardRef(function SessionTimeout(props: SessionTimeoutProps, ref: ForwardedRef<SessionTimeoutRef>): ReactNode {
    const { events } = useSessionTimeoutHooks(props, ref);

    return (
      <DialogSession
        sessionDuration={SESSION_DURATION}
        counterInitialValue={SESSION_TIMEOUT_COUNTER_INITIAL_VALUE}
        onRevoke={events.onRevoke}
        onExtend={events.onExtend}
      />
    );
  }),
);
